import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { FormField } from '~/eds/src/components/FormField/FormField';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';
import { Nullable } from '~/types/Nullable';

const RenameClauseModal = ({
  error,
  onClose,
  onSubmit,
  value,
}: {
  error: string;
  onClose: any;
  onSubmit: any;
  value: string;
}) => {
  const intl = useIntl();
  const [clauseName, setClauseName] = useState<Nullable<string>>(value);
  const [shouldDisplayError, setShouldDisplayError] = useState(false);

  const doesClauseNameExist = !!clauseName?.trim();
  const isClauseNameOverLimit = (clauseName?.length || 0) > 500;
  const isClauseNameUnchanged = value === clauseName;
  const isClauseNameValid =
    doesClauseNameExist && !isClauseNameOverLimit && !isClauseNameUnchanged;

  const footerDefault = `${clauseName?.length ?? 0}/500`;

  const footerError = intl.formatMessage(
    {
      id: 'RenameClauseModal.characterCountError',
      defaultMessage: '{count}/500 (Name cannot be longer than 500 characters)',
      description: 'Character count error message. Example: count = 520',
    },
    { count: clauseName?.length ?? 0 },
  );
  const footer = isClauseNameOverLimit
    ? footerError
    : shouldDisplayError && error
      ? error
      : footerDefault;

  const onCancel = () => {
    setShouldDisplayError(false);
    onClose('');
  };

  return (
    <Modal
      title={intl.formatMessage({
        id: 'RenameClauseModal.title',
        defaultMessage: 'Rename Clause',
        description: 'Modal title for renaming clause',
      })}
      isVisible
      primaryAction={{
        text: intl.formatMessage({
          id: 'RenameClauseModal.saveButton',
          defaultMessage: 'Save',
          description: 'Save button text',
        }),
        disabled: !isClauseNameValid || shouldDisplayError,
        onClick: () => {
          setShouldDisplayError(true);
          onSubmit({ oldName: value, newName: clauseName });
        },
      }}
      onHide={onCancel}
      onCancel={onCancel}
    >
      {/* @ts-ignore */}
      <FormField
        label={intl.formatMessage({
          id: 'RenameClauseModal.formLabel',
          defaultMessage: 'Rename Clause',
          description: 'Form field label for renaming clause',
        })}
        input={TextInput}
        error={
          isClauseNameOverLimit
            ? footerError
            : shouldDisplayError && error
              ? error
              : ''
        }
        footer={footer}
        value={clauseName}
        onChange={(name) => {
          // @ts-ignore
          setClauseName(name);
          setShouldDisplayError(false);
        }}
      />
    </Modal>
  );
};

export default RenameClauseModal;
